<app-page-header
  title="Auftragsdetails"
  subtitle="Alle Informationen zu einem Reflex-Auftrag"
  icon="receipt_long"
  [showBackButton]="true"
  variant="gradient">
</app-page-header>

<!-- Apple-style Content Grid -->
<div class="apple-slide-up">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-icon class="loading-icon">hourglass_empty</mat-icon>
    <p>Lade Auftragsdetails...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="error-container">
    <mat-icon class="error-icon">error_outline</mat-icon>
    <p>{{ error }}</p>
    <button mat-raised-button color="primary" (click)="loadOrderDetails()">
      Erneut versuchen
    </button>
  </div>

  <!-- Order Details -->
  <div *ngIf="!isLoading && !error && (orderDetails$ | async) as order" class="order-details-grid">
    <!-- Order Information Card -->
    <div class="apple-card">
      <div class="apple-card-header">
        <div class="apple-card-icon">
          <mat-icon>receipt_long</mat-icon>
        </div>
        <div class="apple-card-title-section">
          <h3>Auftragsinformationen</h3>
          <p>Auftrags Nr: {{ order.orderNo }}</p>
        </div>
      </div>
      <div class="apple-card-content">
        <div class="apple-info-row highlight-row">
          <span class="apple-info-label">Auftragsnummer</span>
          <span class="apple-info-value">{{ order.orderNo }}</span>
        </div>
        <div class="apple-info-row">
          <span class="apple-info-label">Status</span>
          <span class="apple-info-value">{{ order.statusText }}</span>
        </div>
        <div class="apple-info-row">
          <span class="apple-info-label">Zeitraum</span>
          <span class="apple-info-value">
            {{ order.dateFrom | date:'dd.MM.yyyy' }} - {{ order.dateTo | date:'dd.MM.yyyy' }}
          </span>
        </div>
        <div class="apple-info-row">
          <span class="apple-info-label">Abgerechnet</span>
          <span class="apple-info-value">
            <mat-icon 
              class="status-icon" 
              [class.status-success]="order.isBilled === 1" 
              [class.status-error]="order.isBilled !== 1"
              [matTooltip]="order.isBilled === 1 ? 'Ja' : 'Nein'" 
              matTooltipPosition="right">
              {{ order.isBilled === 1 ? 'check_circle' : 'cancel' }}
            </mat-icon>
          </span>
        </div>
        <div class="apple-info-row">
          <span class="apple-info-label">Bezahlt</span>
          <span class="apple-info-value">
            <mat-icon 
              class="status-icon" 
              [class.status-success]="order.isPaid === 1" 
              [class.status-error]="order.isPaid !== 1"
              [matTooltip]="order.isPaid === 1 ? 'Ja' : 'Nein'" 
              matTooltipPosition="right">
              {{ order.isPaid === 1 ? 'check_circle' : 'cancel' }}
            </mat-icon>
          </span>
        </div>
      </div>
    </div>

    <!-- Customer Information Card -->
    <div class="apple-card">
      <div class="apple-card-header">
        <div class="apple-card-icon customer-icon">
          <mat-icon>business</mat-icon>
        </div>
        <div class="apple-card-title-section">
          <h3>Kundeninformationen</h3>
          <p>{{ order.companyShortName }}</p>
        </div>
      </div>
      <div class="apple-card-content">
        <div class="apple-info-row highlight-row">
          <span class="apple-info-label">Kundennummer</span>
          <span class="apple-info-value">{{ order.customerNo }}</span>
        </div>
        <div class="apple-info-row">
          <span class="apple-info-label">Adressnummer</span>
          <span class="apple-info-value">{{ order.addressNo }}</span>
        </div>
        <div class="apple-info-row">
          <span class="apple-info-label">Firma (Kurzname)</span>
          <span class="apple-info-value">{{ order.companyShortName }}</span>
        </div>
        <div class="apple-info-row">
          <span class="apple-info-label">Firma (vollständig)</span>
          <span class="apple-info-value">{{ order.companyName }}</span>
        </div>
        <div class="apple-info-row">
          <span class="apple-info-label">Kontakt</span>
          <span class="apple-info-value">{{ order.contact }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- No Data State -->
  <div *ngIf="!isLoading && !error && !(orderDetails$ | async)" class="no-data-container">
    <mat-icon class="no-data-icon">inbox</mat-icon>
    <p>Keine Auftragsdetails gefunden</p>
  </div>
</div>
